/**
 * Size Rec Details Queries
 */

import gql from 'graphql-tag'

export const getSizeRecRequestQuery = gql`
  query getSizeRecRequest($shortId: String!) {
    sizeRecRequest: getSizeRecRequest(shortId: $shortId) {
      id
      shortId: short_id
      requestedAt: created_at
      customerId: customer_id
      customerName: customer_name
      subsidiary
      items: design_count
      scan
      status
      recommender
      responsedAt: responsed_at
      sizeRecNotesCount: notes_count
      unit
      gender
      height
      weight
      measurements
      bodyModel: body_model
      inputMethod: input_method
      scannedAt: scanned_at
    }
  }
`

export const getSizeRecRequestProductsQuery = gql`
  query getSizeRecRequestProducts($shortId: String!) {
    sizeRecRequestProducts: getSizeRecRequestProducts(shortId: $shortId) {
      id
      sizeRecId: size_rec_id
      productId: product_id
      productImage: product_image
      productName: product_name
      fitPreference: fit_preference
      fitNote: fit_note
      sizeRecommendation: size_recommendation
      recommenderNote: recommender_note
      notifiedAt: notified_at
    }
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/SizeRecsDetails/data.ts